import React from "react";

import EditableTable from "../../../components/tables/EditableTable";
import MainSelectInput from "../../../components/inputs/MainSelectInput";
import MainTabButton from "../../../components/inputs/MainTabButton";

import { Box, Grid, Modal } from "@mui/material";


class UserLocalSalePopup extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box style={styles.popUpContainer}>
                    <Grid container columnSpacing={1} rowSpacing={2} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>

                        <Grid item md={8}><MainSelectInput {...this.props} id='newLocalsale' value={this.props.newLocalsale} optionsList={this.props.localSaleOptions} label='Local de Venda' handleChange={this.props.handleChangeText} width='100%' /></Grid>

                        <Grid item md={2}>
                            <MainTabButton sx={{ width: { xs: '100%', sm: '100%', md: '95%' } }} {...this.props} onButtonClick={this.props.includeUserLocalSale} title="Inserir" />
                        </Grid>

                        <Grid item md={2}>
                            <MainTabButton sx={{ width: { xs: '100%', sm: '100%', md: '95%' }, backgroundColor: this.props.colors.blueAccent[200] }} {...this.props} onButtonClick={this.props.closePopup} title="Cancelar" />
                        </Grid>

                        <Grid item md={12}>
                            <EditableTable
                                {...this.props}
                                height='40vh'
                                allowEdit
                                noEditButton
                                id='idlocalvenda'
                                data={this.props.userLocalSaleList}
                                columns={this.props.userLocalSaleColumns}
                                rowId='idlocalvenda'
                                totalSize={this.props.userLocalSaleTotalSize}
                                onPageChange={this.props.onUserLocalSaleTableChange}
                                onEditRow={this.props.onUserLocalSaleTableEdit}
                                onRowDoubleClick={() => { }}
                                isLoading={this.props.isLoadingUserLocalSaleTable}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        )
    }

}

export default UserLocalSalePopup;

const styles = {
    popUpContainer: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        width: '80%',
        height: '60vh',
        maxWidth: '900px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}